import StarRank from '@/app/(main)/starrank';

const StarRankRoute = () => {
  // 별별랭킹 페이지 하위 추가 라우트가 필요하지 않아 서비스로 by-pass
  return <StarRank />;
};

export default StarRankRoute;
